/* @flow */
import React from 'react';
// $FlowIgnore
import { MdSearch } from 'react-icons/md';

export default function SearchIcon({
  style
}: Object): React.Element {
  return <MdSearch style={style} />;
}
